import type {
  BroadcastDirectorMessageResponse,
  EligiblePlayersResponse,
  EligibleTournamentsResponse,
  Message,
  MessageThread,
  MessageThreadListResponse,
  MessagesUnreadCountResponse,
} from '@swiss-magic/shared-types';
import { get, post } from './core';

export function getMessageThreads(): Promise<MessageThreadListResponse> {
  return get<MessageThreadListResponse>('/player/messages/threads');
}

export function getMessagesUnreadCount(): Promise<MessagesUnreadCountResponse> {
  return get<MessagesUnreadCountResponse>('/player/messages/unread-count');
}

export function getEligibleTournaments(): Promise<EligibleTournamentsResponse> {
  return get<EligibleTournamentsResponse>('/player/messages/eligible-tournaments');
}

export function getMessageThread(threadId: string): Promise<MessageThread> {
  return get<MessageThread>(`/player/messages/threads/${threadId}`);
}

export function sendPlayerMessage(
  tournamentId: string,
  body: string,
): Promise<Message> {
  return post<Message>('/player/messages/threads', { tournamentId, body });
}

export function markThreadRead(threadId: string): Promise<{ ok: boolean }> {
  return post<{ ok: boolean }>(`/player/messages/threads/${threadId}/read`);
}

// ---------------- Director surface (story 087) ----------------

const dirBase = (tournamentId: string) =>
  `/tournaments/${tournamentId}/messages`;

export function getDirectorMessageThreads(
  tournamentId: string,
): Promise<MessageThreadListResponse> {
  return get<MessageThreadListResponse>(`${dirBase(tournamentId)}/threads`);
}

export function getDirectorMessagesUnreadCount(
  tournamentId: string,
): Promise<MessagesUnreadCountResponse> {
  return get<MessagesUnreadCountResponse>(`${dirBase(tournamentId)}/unread-count`);
}

export function getEligiblePlayers(
  tournamentId: string,
): Promise<EligiblePlayersResponse> {
  return get<EligiblePlayersResponse>(`${dirBase(tournamentId)}/eligible-players`);
}

export function getDirectorMessageThread(
  tournamentId: string,
  threadId: string,
): Promise<MessageThread> {
  return get<MessageThread>(`${dirBase(tournamentId)}/threads/${threadId}`);
}

export function sendDirectorMessage(
  tournamentId: string,
  playerUserId: string,
  body: string,
): Promise<Message> {
  return post<Message>(dirBase(tournamentId), { playerUserId, body });
}

export function markDirectorThreadRead(
  tournamentId: string,
  threadId: string,
): Promise<{ ok: boolean }> {
  return post<{ ok: boolean }>(
    `${dirBase(tournamentId)}/threads/${threadId}/read`,
  );
}

export function broadcastDirectorMessage(
  tournamentId: string,
  playerUserIds: string[],
  body: string,
): Promise<BroadcastDirectorMessageResponse> {
  return post<BroadcastDirectorMessageResponse>(`${dirBase(tournamentId)}/broadcast`, {
    playerUserIds,
    body,
  });
}
